/**
 * @ngdoc controllers
 * @memberof mercury.modules.time
 * @name TimeClockListCtrl
 */
angular.module('mercury.modules.time.clock')
.controller('TimeClockListCtrl', ["dialog", "$filter", "$q", "reporttime", "$scope", "title", "TimePayrollAdjustment", "TimeClock", "TimeStaff", "TimeRoles", "userinfo", "features", "PayRules", "TimeConstants", "shiftHelpers", function(dialog, $filter, $q, reporttime, $scope, title,
    TimePayrollAdjustment, TimeClock, TimeStaff, TimeRoles, userinfo, features, PayRules, TimeConstants, shiftHelpers) {
  title.set('Staff Clocks');

  $scope.showDeleted = false;
  $scope.clockSaving = null;
  $scope.clockSavePromise = null;
  $scope.activePackages = [];

  var breaksOverlap = false;

  function fixTotalMinutes() {
    angular.forEach($scope.clocks, function(clock) {
      clock.length = TimeClock.getClockinLength(clock.clockoutTime, clock.clockinTime) - (shiftHelpers.calculateTotalUnpaidBreakDuration(clock).toFixed(2));
      clock.lengthUnrounded = TimeClock.getClockinLengthUnrounded(clock.clockoutTime, clock.clockinTime) - (shiftHelpers.calculateTotalUnpaidBreakDuration(clock));
    });
  }

  function loadListData() {
    var loadingPromises = {
      timeClocks: TimeClock.getAll(reporttime.start(), reporttime.end()),
      staffMembers: TimeStaff.getAllActive(),
      staffRoles: TimeRoles.getAllActive()
    };

    $scope.loading = $q.all(loadingPromises);
    $scope.loading.then(function(result) {
      $scope.clocks = $filter('orderBy')(result.timeClocks, [
        function(clock) {
          return clock.staffMemberLastName === null ? clock.staffMemberFirstName : clock.staffMemberFirstName + ' ' + clock.staffMemberLastName;
        },
        function(clock) {
          return moment(clock.clockinTime).unix();
        }
      ]);
      $scope.roles = result.staffRoles;
      $scope.staff = result.staffMembers;

      fixTotalMinutes();

      if (userinfo.companyHasPermission('Payroll')) {
        // keep loading rules
        var loadingPromises = {
          rules: TimePayrollAdjustment.getAllActive(),
          availablePackages: PayRules.getAll()
        };

        $scope.loading = $q.all(loadingPromises);
        $scope.loading.then(function(result) {
          $scope.rules = result.rules;
          $scope.activePackages = $filter('filter')(result.availablePackages, function(package) {
            return package.activation != null;
          });
        });
      }
    });
  }

  /**
   * Checks the length of the clock and displays errors if its too small or large
   * @param {*} shiftLength, the length of the shift
   */
  $scope.shiftCheck = function(shiftLength) {
    if (shiftLength <= 0) {
      dialog.alert('This shift ends before it starts are you sure you want to continue.');
    }
    if (shiftLength >= 24) {
      dialog.alert('This shift is greater than 24 hours, are you sure you want to continue.');
    }
  };

  // use list of member roles to search for the correct role and return the name
  var getRoleName = function(memberRoles, roleId) {
    var role = memberRoles.filter(function(r) {
      return r.roleId === roleId;
    })[0];
    return role ? role.roleName : null;
  };

  /**
   * if the role is updated then we want to remove all the overrides for this clockin then save
   */
  $scope.updateRole = function(clock, roleId) {
    clock.rules.forEach(function(rule) {
      if (rule.override) {
        rule.override.deletedAt = moment().format();
      }
    });
    clock.roleName = getRoleName(clock.memberRoles, roleId);
    $scope.saveClock(clock);
  };

  /**
   * Callback for updating any of the fields of a clockin in the clockin table.
   */
  $scope.saveClock = function(clock, refresh) {
    //Update the value used in the 'Total Time' column.

    clock.length = TimeClock.getClockinLength(clock.clockoutTime, clock.clockinTime);
    clock.lengthUnrounded = TimeClock.getClockinLengthUnrounded(clock.clockoutTime, clock.clockinTime);

    $scope.shiftCheck(clock.length);

    $scope.clockSaving = clock.id;
    $scope.clockSavePromise = TimeClock.update(clock);
    $scope.clockSavePromise.then(function(savedClock) {
      clock.id = savedClock.id;
      clock.clockinTime = savedClock.clockinTime;
      clock.clockoutTime = savedClock.clockoutTime;
      clock.isCompanyClockin = savedClock.isCompanyClockin;
      clock.adjustedHourlyRate = savedClock.adjustedHourlyRate;
      clock.hourlyRate = savedClock.hourlyRate;
      clock.rules = savedClock.rules;
      clock.length = TimeClock.getClockinLength(clock.clockoutTime, clock.clockinTime);
      clock.lengthUnrounded = TimeClock.getClockinLengthUnrounded(clock.clockoutTime, clock.clockinTime);
      $scope.clockSaving = null;

      // reload page after data change comes from the input payrate dialog
      if (refresh) {
        loadListData();
      }
    });
  };

  /**
   * Finds all role options a staff member can have
   * @param {*} clockin, the clockin of the wanted role options
   * @returns all roles that staff member of the given shift can have
   */
  $scope.roleOptions = function(clockin) {
    var staff = $filter('filter')($scope.staff, {id: clockin.staffMemberId});

    // The staff member this clock belongs to has been deleted. Return the clock
    // since it also has a roleId and roleName and these will prevent the select
    // box rendering blank.
    if (staff.length === 0) {
      return [clockin];
    }

    clockin.memberRoles = staff[0].memberRoles;
    return staff[0].memberRoles;
  };

  /**
   * Adds the new clock created when in the 'Add Clock' dialog
   * @param {clock} newClock, The new clock to be added
   */
  $scope.addClock = function(newClock) {
    $scope.addingClock = TimeClock.create(newClock);
    $scope.addingClock.then(function(createdClock) {
      createdClock.length = TimeClock.getClockinLength(createdClock.clockoutTime, createdClock.clockinTime);
      createdClock.lengthUnrounded = TimeClock.getClockinLengthUnrounded(createdClock.clockoutTime, createdClock.clockinTime);

      $scope.shiftCheck(createdClock.length);

      $scope.clocks.push(createdClock);

      fixTotalMinutes();

      $scope.clocks = $filter('orderBy')($scope.clocks, [
        function(clock) {
          return clock.staffMemberLastName === null ? clock.staffMemberFirstName : clock.staffMemberFirstName + ' ' + clock.staffMemberLastName;
        },
        function(clock) {
          return moment(clock.clockinTime).unix();
        }
      ]);

      dialog.close();

    });
  };

  /**
   * Method the goes through all breaks in a clock array and compares every break against each other to check if the overlap
   * @param {int} clockIndex, the index of the clock that related breaks are in
   * @returns true if the breaks overlap, false if not
   */
  $scope.breaksOverlap = function() {
    var clockBreaks = $scope.newClock.breaks;

    // If there is not breaks then none overlap
    if (!clockBreaks) {
      return false;
    }

    for (var i = 0; i < clockBreaks.length; i++) {
      var breakA = clockBreaks[i];

      // Compare breakA against all other breaks to see if it overlaps
      for (var j = 0; j < clockBreaks.length; j++) {
        // Don't compare a break against itself
        if (j == i) {
          break;
        }

        var breakB = clockBreaks[j];

        // Validate that the break does not overlap another break
        if (breakA.breakStart < breakB.breakEnd && breakA.breakEnd > breakB.breakStart) {
          breaksOverlap = true;
          return true;
        }
      }
    }
    breaksOverlap = false;
    return false;
  };

  /**
   * Validates a given break and sets its validityError flag
   * @param {break} clockBreak, the break to be validated
   * @param {clock} clock , the clock the break is being applied to
   * @returns true if break is valid, false if not
   */
  $scope.validateBreak = function(clockBreak, clock) {

    // If there is no breaks then valid
    if (!clock.breaks) {
      return true;
    }

    clockBreak.validityError = true;
    if (clockBreak.breakStart < clock.clockinTime) {
      return false;
    } else if (clockBreak.breakEnd > clock.clockoutTime) {
      return false;
    } else if (clockBreak.breakStart > clockBreak.breakEnd) {
      return false;
    } else {
      clockBreak.validityError = false;
      return true;
    }
  };

  /**
   * Gets halfway through the clock to intialise a breakStart value
   * @param {clock} clock, the clock that the break is being applied to
   * @returns {moment} moment, representing the time half way through the clock
   */
  var initialBreakStartTime = function(clock) {
    var duration = moment.duration(moment(clock.clockoutTime).diff(moment(clock.clockinTime)));
    var halfway = Math.round(duration.asHours() / 2);
    return moment(clock.clockinTime).add(halfway, 'hours');
  };

  /**
   * Adds a new break to the newClock being created
   */
  $scope.addBreak = function() {
    var startTime = initialBreakStartTime($scope.newClock);
    var newBreak = {
      type: TimeConstants.ShiftType.Clockin,
      breakStart: startTime.format(),
      breakEnd: startTime.add(30, 'minutes').format(),
      paid: false
    };

    $scope.newClock.breaks.push(newBreak);
  };

  /**
   * Removes a break from newClock
   * @param {int} breakIndex, the index of the break in its array
   */
  $scope.deleteBreak = function(breakIndex) {
    // Remove the break from the array so it is not displayed in UI
    $scope.newClock.breaks.splice(breakIndex, 1);
  };

  /**
   * Evaluates whether the 'Add Clock' button inside the add dialog should be disabled or not.
   * Currently only based on on whether breaks are valid
   * @returns true if the elements in dialog are valid, false if not
   */
  $scope.disableAdd = function() {
    // Goes through every break in newClock and re-validates the break
    // If the validateBreak methods returns false at any point then disable then disable the button
    for (var breakIndex in $scope.newClock.breaks) {
      var clockBreak = $scope.newClock.breaks[breakIndex];
      var result = $scope.validateBreak(clockBreak, $scope.newClock);

      // If break not valid disable button
      if (!result) {
        return true;
      }
    }

    // If the above check passes then it comes down to if any of the breaks overlap
    return breaksOverlap;
  };

  /**
   * Callback for clicking 'Add Clock'.
   */
  $scope.openAddDialog = function() {
    $scope.noStaffError = false;

    if ($scope.staff.length !== 0) {
      $scope.newClock = {
        staffMemberId: angular.copy($scope.staff[0].id),
        roleId: angular.copy($scope.staff[0].defaultMemberRoleRoleId),
        roleName: angular.copy($scope.staff[0].defaultMemberRoleRoleName),
        hourlyRate: angular.copy($scope.staff[0].defaultMemberRoleRoleHourlyRate),
        clockinTime: moment(reporttime.start()).format(),
        clockoutTime: moment(reporttime.start()).add(3, 'hours').format(),
        breaks: []
      };
    } else {
      $scope.noStaffError = true;
    }

    dialog.open({
      templateUrl: 'modules/time/clock/create.tpl.html',
      scope: $scope
    });
  };

  /**
   * Callback for changing the staff member in the add clock dialog.
   */
  $scope.addClockStaffChanged = function() {
    var staff = $filter('filter')($scope.staff, {id: $scope.newClock.staffMemberId})[0];

    $scope.newClock.roleId = staff.defaultMemberRoleRoleId;
    $scope.addClockStaffRoleChanged();
  };

  /**
   * Callback for changing the role in the add clock dialog.
   */
  $scope.addClockStaffRoleChanged = function() {
    var staff = $filter('filter')($scope.staff, {id: $scope.newClock.staffMemberId})[0];
    var memberRole = $filter('filter')(staff.memberRoles, {roleId: $scope.newClock.roleId})[0];

    $scope.newClock.hourlyRate = memberRole.hourlyRate;

    // Small hack for getting around the problem where changing the hourlyRate updates
    // the newClock's hourlyRate from undefined to null.
    // the latter will trigger a validation error
    // See LOADED-1226
    if ($scope.newClock.hourlyRate === null) {
      delete $scope.newClock.hourlyRate;
    }
  };

  /**
   * Callback for clicking the delete icon for a clockin row.
   */
  $scope.deleteClock = function(clock) {

    if (clock.datestampDeleted === null) {
      clock.datestampDeleted = moment().format();
    } else {
      clock.datestampDeleted = null;
    }

    TimeClock.update(clock)
    .then(function(updatedClock) {
      // Incase we deleted a POS clock, ensure the id of the input clock is correct
      clock.id = updatedClock.id;

      fixTotalMinutes();
    }, function(error) {
      dialog.alert(error.data.message);
    });
  };

  /**
   * Show the audit history popup for the selected clock.
   */
  $scope.showHistory = function(clock) {
    dialog.open({
      templateUrl: 'modules/time/clock/popupaudit.tpl.html',
      controller: 'TimeClockPopupauditCtrl',
      resolve: {
        clockinId: function() {
          return clock.id;
        }
      }
    });
  };

  // initial loading of the page
  loadListData();
}]);
